import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Paper,
  Divider,
  Collapse,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  useTheme,
  useMediaQuery
} from '@mui/material';
import {
  ExpandLess,
  ExpandMore,
  QuestionMarkTwoTone,
  ComputerTwoTone,
  EmailTwoTone,
  MessageTwoTone,
  FilterAltTwoTone,
  GpsFixedTwoTone,
  GroupAddTwoTone,
  EditTwoTone,
  AccountCircleTwoTone,
  ExitToAppTwoTone,
  CampaignOutlined,
  AssessmentTwoTone,
  CalendarMonthTwoTone,
  ShoppingCartCheckoutTwoTone,
  SocialDistanceTwoTone,
  EmojiEmotionsTwoTone,
  BookmarksTwoTone,
  CalendarTodayTwoTone,
  AddIcCallTwoTone,
  FolderSharedTwoTone,
  MoveDownTwoTone,
  GroupTwoTone,
  Close,
  PlayArrowTwoTone
} from '@mui/icons-material';

// Componente para explicações detalhadas
function TopicExplanation({ topic, sectionId, onClose }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const getExplanationContent = (sectionId, topic) => {
    const explanations = {
      'comece-aqui': {
        'Convide corretores para participar da sua equipe': {
          title: 'Convidar Corretores',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Convide corretores para fazer parte da sua equipe no CRM:
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li>Estabeleça um critério de seleção para os corretores
                    <ul>
                      <li>Considere a experiência anterior</li>
                      <li>Verifique a disponibilidade de horário</li>
                      <li>Avalie o desempenho em campanhas anteriores</li>
                    </ul>
                  </li>
                  <li>Envie convites para os corretores selecionados</li>
                  <li>Acompanhe as respostas e confirme a participação</li>
                  <li>Forneça orientações iniciais sobre o uso do CRM</li>
                  <li>Monitore a integração dos novos corretores na equipe</li>
                  <li>Combine os horários de atendimento com a disponibilidade dos corretores</li>
                  <li>Oriente os corretores sobre como participar da Escala Online</li>
                  <li>Ofereça suporte contínuo e treinamento adicional</li>
                  <li>Realize reuniões regulares para feedback e melhorias</li>
                  <li>Incentive a colaboração entre os membros da equipe</li>
                  <li>Estabeleça metas claras e acompanhe o progresso</li>
                  <li>Reconheça e recompense o desempenho excepcional</li>
                  <li>Revise e ajuste a equipe conforme necessário</li>
                  <li>Mantenha uma comunicação aberta e transparente</li>
                </ol>
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                💡 Dica: Configure diferentes escalas para dias da semana e finais de semana.
              </Typography>
            </Box>
          )
        },
        'Crie campanhas de marketing - Leads Campanha': {
          title: 'Campanhas de Marketing',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Configure as campanhas de marketing da sua equipe:
              </Typography>
              <Typography variant="body2" component="div">
                <ul>
                  <li>As campanhas de marketing são essências para o recebimento de leads</li>
                  <li>Defina objetivos claros para cada campanha</li>
                  <li>Escolha os canais de marketing apropriados</li>
                  <li>Incentive a participação da equipe nas campanhas
                    <ul>
                      <li>Faça reuniões regulares para discutir estratégias</li>
                      <li>Levante recursos em equipe para impulsionar campanhas</li>
                      <li>Equipes engajadas são mais produtivas</li>
                      <li>Compartilhe sucessos e aprendizados</li>
                    </ul>
                  </li>
                  <li>Monitore o desempenho das campanhas regularmente</li>
                  <li>Ajuste as campanhas conforme a demanda e feedback da equipe</li>
                  <li>Comunique os resultados das campanhas para toda a equipe</li>
                </ul>
              </Typography>
            </Box>
          )
        },
        'Acompanhe os resultados - Dashboard': {
          title: 'Acompanhe os Resultados',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Acompanhe os resultados das suas campanhas e escalas diárias:
              </Typography>
              <Typography variant="body2" component="div">
                <ul>
                  <li>Use o Dashboard para visualizar estatísticas de leads</li>
                  <li>Acompanhe a performance da equipe e conversões</li>
                  <li>Analise métricas importantes para otimizar estratégias</li>
                  <li>Acompanhe os leads de cada corretor</li>
                  <li>Analise os resultados das campanhas</li>
                </ul>
              </Typography>
            </Box>
          )
        },
        'Crie escalas diárias - Escala OnLine': {
          title: 'Escalas Diárias',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Configure as escalas diárias da sua equipe:
              </Typography>
              <Typography variant="body2" component="div">
                <ul>
                  <li>As escalas diárias são essenciais para o recebimento de leads</li>
                  <li>Defina horários de atendimento claros</li>
                  <li>Distribua os corretores de forma equilibrada</li>
                  <li>Monitore o desempenho das escalas regularmente</li>
                  <li>Ajuste as escalas conforme a demanda e feedback da equipe</li>
                  <li>Comunique as escalas com antecedência para evitar conflitos</li>
                  <li>Incentive a pontualidade e comprometimento dos corretores</li>
                  <li>Revise as escalas semanalmente para melhorias contínuas</li>
                  <li>Garanta que todos os membros da equipe estejam cientes de suas responsabilidades</li>
                  <li>Oriente os corretores à Participar do Online</li>
                </ul>
              </Typography>
            </Box>
          )
        },
        'Verifique os Leads represados - Leads Distribuição': {
          title: 'Leads Represados',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Os leads represados são aqueles que não foram distribuídos devido à falta de corretores disponíveis na escala.
              </Typography>
              <Typography variant="body2" component="div">
                <ul>
                  <li>Verifique regularmente o menu "Leads Distribuição" para identificar leads represados</li>
                  <li>Distribua manualmente os leads represados para corretores disponíveis</li>
                  <li>Considere ajustar as escalas diárias para evitar represamento futuro</li>
                  <li>Comunique os corretores sobre a importância de manter a escala atualizada</li>
                  <li>Monitore o tempo médio de represamento e tome medidas para reduzi-lo</li>
                  <li>Garanta que todos os leads sejam atendidos em tempo hábil para maximizar as chances de conversão</li>
                </ul>
              </Typography>
            </Box>
          )
        },
      },

      'escala-online': {
        'Crie uma nova escala diária': {
          title: 'Criar uma nova escala diária',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                A escala é fundamental para o recebimento de leads.
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li>Clique no botão "+" no canto inferior direito para iniciar a criação de uma nova escala.</li>
                  <li>Selecione a forma de distribuição dos leads:</li>
                  <ol>
                    <li>Randômica </li>
                    <ol>
                      <li>A ordem de distribuição é definida através do sorteio diário entre os corretores disponíveis.</li>
                    </ol>
                    <li>Cadastro</li>
                    <ol>
                      <li>A ordem de distribuição é definida pela posição na escala de disponibilidade diária.</li>
                    </ol>
                    <li>Sequencial</li>
                    <ol>
                      <li>A ordem de distribuição é definida por um sorteio inicial e a distribuição segue de forma sequencial até uma nova escala.</li>
                    </ol>
                  </ol>
                  <li>Selecione a criação por data ou por período.</li>
                  <ol>
                    <li>Data: Cria uma escala para um dia específico.</li>
                    <li>Período: Cria uma escala que se repete em um intervalo de dias.</li>
                  </ol>
                  <li>Selecione o horário de início e fim da escala.</li>
                  <ol>
                    <li>Considere os horários de recebimento de leads ao definir os horários.</li>
                    <li>O horário de início deve ser anterior ao horário de fim.</li>
                  </ol>
                  <li>Informe a equipe sobre a nova escala.</li>
                  <li>Monitore a adesão à escala e faça ajustes conforme necessário.</li>
                  <li>Revise as escalas semanalmente para melhorias contínuas.</li>
                </ol>
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                💡 Dica: O sorteio é realizado utilizando o algoritmo Fisher-Yates Shuffle.
              </Typography>
            </Box>
          )
        },
        'Coloque a escala em execução': {
          title: 'Executar Escala',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Colocar a escala em execução é essencial para que os corretores possam receber leads.
              </Typography>
              <Typography variant="body2" component="div">
                <ul>
                  <li>Na escala selecionada clique no botão Corretores e verifique se os corretores estão disponíveis nos horários definidos.</li>
                  <li>Confirme se a escala foi criada corretamente com os horários e corretores desejados e faça os ajustes necessários, antes do fechamento da escala.</li>
                  <li>Clique no botão "Ordenar" para definir a ordem de recebimento e fechamento da escala.</li>
                  <li>Clique no botão "Executar" para colocar a escala em execução.</li>
                  <li>Com a escala em execução, os leads serão distribuídos conforme a ordem definida.</li>
                  <li>Habilite os corretores atrasados a qualquer momento.</li>
                  <li>Comunique a equipe sobre o início da escala e suas responsabilidades.</li>
                  <li>A escala possui as seguintes situações:</li>
                  <ul>
                    <li>Prevista: Escala criada e aberta para os corretores informar sua disponibilidade, mas ainda não está em execução.</li>
                    <li>Ordenada: Escala com ordem de recebimento definida e fechada, mas ainda não está em execução.</li>
                    <li>Programada: Escala em execução para uma data futura.</li>
                    <li>Em Execução: Escala ativa e distribuindo leads.</li>
                    <li>Suspensa: Escala temporariamente pausada e sem distribuição de leads.</li>
                    <li>Encerrada: Escala concluída e não está mais ativa.</li>
                  </ul>
                </ul>
              </Typography>
            </Box>
          )
        }
      },
      'leads-campanha': {
        'Adicione uma nova campanha': {
          title: 'Adicionar Campanha',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Adicione uma nova campanha de marketing para recepcionar leads:
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li>Clique no botão "+" no canto inferior direito para iniciar a criação de uma nova campanha.</li>
                  <li>Preencha os detalhes da campanha, como nome e duração.</li>
                  <li>Selecione o Canal de captação (Instagram, Facebook, etc.).</li>
                  <li>Selecione o Tipo de campanha (Meta, FormQ1, FormQ2, Chatbot).</li>
                  <li>Configure parâmetros de cada campanha</li>
                  <li>Use o link do formulário de captação para vincular aos anúncios.</li>
                  <li>Use o QRCode em materiais promocionais para direcionar os leads ao formulário de captação.</li>
                  <li>Ou integre sua campanha com o Meta Ads</li>
                  <li>Tipos de Campanha</li>
                  <ul>
                    <li>Meta (Facebook Ads): Utilize a integração com os formulários instantâneos do Meta Ads para captação de leads.</li>
                    <li>FormQ1: Formulário simples com campos básicos para captação rápida de leads.</li>
                    <li>FormQ2: Formulário detalhado com campos adicionais para qualificação de leads.</li>
                    <li>Chatbot: Utilize um chatbot para interagir com os leads e melhorar a captação.</li>
                  </ul>





                </ol>
              </Typography>
            </Box>
          )
        },
        'Campanha tipo: FormQ1': {
          title: 'Campanha FormQ1',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Campanha tipo FormQ1 - Formulário simples com campos básicos para captação rápida de leads. 
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li>Campos do formulário: Nome e Telefone</li>
                  <li>Objetivo: Captar leads com informações essenciais para contato inicial.</li>
                  <li>Uso: Leads com um grau de interesse mais alto que o normal.</li>
                  <li>Vinculação com qualquer meio digital através de links ou QR Codes.</li>
                  <li>Volume de captação: Médio</li>
                </ol>
              </Typography>
            </Box>
          )
        },
        'Campanha tipo: FormQ2': {
          title: 'Campanha FormQ2',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Campanha tipo FormQ2 - Formulário detalhado com campos adicionais para qualificação de leads.
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li>Campos do formulário: Nome, Telefone, E-mail, Interesse (Compra, Aluguel, etc.), Faixa de Preço, Localização Preferida.</li>
                  <li>Objetivo: Captar leads com informações detalhadas para melhor qualificação e segmentação.</li>
                  <li>Uso: Leads que necessitam de um contato mais elaborado e personalizado.</li>
                  <li>Vinculação com qualquer meio digital através de links ou QR Codes.</li>
                  <li>Volume de captação: Baixo</li>
                </ol>
              </Typography>
            </Box>
          ) 
        },
        'Campanha tipo: Chatbot': {
          title: 'Campanha Chatbot',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Campanha tipo Chatbot - Utilize um chatbot para interagir com os leads e melhorar a captação.
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li>Interação: O chatbot faz perguntas interativas para captar informações dos leads.</li>
                  <li>Objetivo: Engajar os leads através de uma conversa dinâmica e personalizada.</li>
                  <li>Uso: Leads que preferem uma abordagem mais interativa e moderna.</li>
                  <li>Vinculação com qualquer meio digital através de links ou QR Codes.</li>
                  <li>Volume de captação: Variável, dependendo do engajamento do chatbot.</li>
                </ol>
              </Typography>
            </Box>
          )
        }
      },
      'meus-leads': {
        'Visualizar leads atribuídos a você': {
          title: 'Visualização de Leads Pessoais',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Acesse e gerencie seus leads pessoais:
              </Typography>
              <Typography variant="body2" component="div">
                <ul>
                  <li>Lista completa dos seus leads</li>
                  <li>Filtros por status, data, origem</li>
                  <li>Informações detalhadas de cada lead</li>
                  <li>Histórico de interações</li>
                </ul>
              </Typography>
              <Typography variant="body2" color="primary" sx={{ mt: 2 }}>
                📊 Use os filtros para organizar melhor sua lista de leads.
              </Typography>
            </Box>
          )
        },
        
        'Atualizar status dos leads': {
          title: 'Atualização de Status',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Mantenha o status dos seus leads sempre atualizado:
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li>Selecione o lead desejado</li>
                  <li>Clique em "Editar Status"</li>
                  <li>Escolha o novo status apropriado</li>
                  <li>Adicione observações se necessário</li>
                  <li>Salve as alterações</li>
                </ol>
              </Typography>
              <Typography variant="body2" color="warning.main" sx={{ mt: 2 }}>
                ⚠️ Importante: Sempre atualize o status após cada contato.
              </Typography>
            </Box>
          )
        }
      },
      'lembretes': {
        'Criar novos lembretes': {
          title: 'Criação de Lembretes',
          content: (
            <Box>
              <Typography variant="body1" paragraph>
                Organize sua agenda com lembretes eficientes:
              </Typography>
              <Typography variant="body2" component="div">
                <ol>
                  <li>Clique em "Novo Lembrete"</li>
                  <li>Defina título e descrição</li>
                  <li>Configure data e horário</li>
                  <li>Selecione tipo de notificação</li>
                  <li>Vincule a um lead se aplicável</li>
                </ol>
              </Typography>
            </Box>
          )
        }
      }
    };

    return explanations[sectionId]?.[topic] || null
    // {
    // title: topic,
    // content: (
    //   <Typography variant="body1">
    //     Explicação detalhada para "{topic}" em desenvolvimento.
    //   </Typography>
    // )
    // };
  };

  const explanation = getExplanationContent(sectionId, topic);

  return (
    explanation && (
      <Dialog
        open={true}
        onClose={onClose}
        maxWidth="md"
        fullWidth
        fullScreen={isMobile}
        sx={{
          '& .MuiDialog-paper': {
            margin: isMobile ? 0 : 2,
            width: isMobile ? '100%' : 'auto',
            height: isMobile ? '100%' : 'auto'
          }
        }}
      >
        <DialogTitle sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexDirection: isMobile ? 'column' : 'row',
          gap: isMobile ? 1 : 0
        }}>
          <Typography
            variant={isMobile ? "h6" : "h5"}
            sx={{
              textAlign: isMobile ? 'center' : 'left',
              fontSize: isMobile ? '1.1rem' : '1.25rem'
            }}
          >
            {explanation.title}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{
          padding: isMobile ? theme.spacing(2) : theme.spacing(3),
          flex: 1,
          display: 'flex',
          flexDirection: 'column'
        }}>
          {explanation.content}
        </DialogContent>
        <DialogActions sx={{
          padding: isMobile ? theme.spacing(2) : theme.spacing(3),
          justifyContent: 'center'
        }}>
          <Button
            onClick={onClose}
            variant="contained"
            fullWidth={isMobile}
            size={isMobile ? "large" : "medium"}
          >
            Entendi
          </Button>
        </DialogActions>
      </Dialog>
    )
  );
}

export default function Tutorial({ user }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));

  const [openSections, setOpenSections] = useState({});
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);

  const handleToggleSection = (section) => {
    setOpenSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const handleTopicClick = (topic, sectionId) => {
    setSelectedTopic(topic);
    setSelectedSection(sectionId);
  };

  const handleCloseExplanation = () => {
    setSelectedTopic(null);
    setSelectedSection(null);
  };

  const tutorialSections = [
    {
      id: 'comece-aqui',
      title: 'Começe aqui!',
      icon: <ComputerTwoTone color="primary" />,
      description: 'Como usar o CRM GIMOV',
      topics: [
        'Convide corretores para participar da sua equipe',
        'Crie escalas diárias - Escala OnLine',
        'Crie campanhas de marketing - Leads Campanha',
        'Verifique os Leads represados - Leads Distribuição',
        'Acompanhe os resultados - Dashboard',
      ],
      condition: user?.hascrm && user?.rules?.includes('Administrador')
    },
    {
      id: 'escala-online',
      title: 'Escala OnLine',
      icon: <CalendarMonthTwoTone color="primary" />,
      description: 'Como gerenciar escalas de atendimento online',
      topics: [
        'Selecione a opção Escala OnLine no menu lateral',
        'Crie uma nova escala diária',
        'Coloque a escala em execução',
        'Caso necessário, suspenda a escala ativa',
      ],
      condition: user?.hascrm && user?.rules?.includes('Administrador')
    },
    {
      id: 'leads-campanha',
      title: 'Leads Campanha',
      icon: <ShoppingCartCheckoutTwoTone color="primary" />,
      description: 'Como gerenciar leads de campanhas de marketing',
      topics: [
        'Selecione a opção Leads Campanha no menu lateral',
        'Adicione uma nova campanha',
        'Selecione o tipo de campanha',
        'Campanha tipo: Meta (Facebook Ads)',
        'Campanha tipo: FormQ1',
        'Campanha tipo: FormQ2',
        'Campanha tipo: Chatbot',
      ],
      condition: user?.hascrm && user?.rules?.includes('Administrador')
    },
    {
      id: 'leads-distribuicao',
      title: 'Leads Distribuição',
      icon: <SocialDistanceTwoTone color="primary" />,
      description: 'Como distribuir leads automaticamente para a equipe',
      topics: [
        'Configurar regras de distribuição',
        'Definir critérios de atribuição',
        'Gerenciar fila de leads',
        'Redistribuir leads não atendidos',
        'Configurar notificações automáticas'
      ],
      condition: user?.hascrm && user?.rules?.includes('Administrador')
    },
    {
      id: 'corretor-leads',
      title: 'Corretor Leads',
      icon: <GroupTwoTone color="primary" />,
      description: 'Como gerenciar leads atribuídos aos corretores',
      topics: [
        'Visualizar leads por corretor',
        'Acompanhar performance individual',
        'Reatribuir leads entre corretores',
        'Monitorar follow-up dos atendimentos'
      ],
      condition: user?.hascrm && user?.rules?.includes('Administrador')
    },
    {
      id: 'dashboard-crm',
      title: 'Dashboard CRM',
      icon: <AssessmentTwoTone color="primary" />,
      description: 'Como utilizar o dashboard para análise de leads e performance',
      topics: [
        'Visualizar estatísticas de leads',
        'Acompanhar performance da equipe',
        'Analisar conversões e métricas',
        'Gerar relatórios de vendas',
        'Configurar temporizadores automáticos'
      ],
      condition: user?.hascrm && user?.rules?.includes('Administrador')
    },
    {
      id: 'meus-leads',
      title: 'Leads',
      icon: <EmojiEmotionsTwoTone color="primary" />,
      description: 'Como gerenciar seus leads pessoais',
      topics: [
        'Visualizar leads atribuídos a você',
        'Atualizar status dos leads',
        'Agendar follow-ups',
        'Registrar interações e observações',
        'Converter leads em clientes'
      ],
      condition: user?.hascrm
    },
    {
      id: 'lembretes',
      title: 'Lembretes',
      icon: <BookmarksTwoTone color="primary" />,
      description: 'Como gerenciar lembretes e avisos importantes',
      topics: [
        'Criar novos lembretes',
        'Configurar data e hora de notificação',
        'Categorizar por tipo de atividade',
        'Marcar lembretes como concluídos',
        'Configurar lembretes recorrentes'
      ],
      condition: user?.hascrm
    },
    {
      id: 'tarefas',
      title: 'Tarefas',
      icon: <CalendarTodayTwoTone color="primary" />,
      description: 'Como gerenciar tarefas e atividades diárias',
      topics: [
        'Criar novas tarefas',
        'Definir prazos e prioridades',
        'Acompanhar progresso das atividades',
        'Marcar tarefas como concluídas',
        'Filtrar tarefas por período'
      ],
      condition: user?.hascrm
    },
    {
      id: 'participar-online',
      title: 'Participar OnLine',
      icon: <AddIcCallTwoTone color="primary" />,
      description: 'Como participar de escalas de atendimento online',
      topics: [
        'Entrar em escalas disponíveis',
        'Configurar status de disponibilidade',
        'Receber leads automaticamente',
        'Gerenciar tempo de atendimento'
      ],
      condition: user?.hascrm
    },
    {
      id: 'carteira',
      title: 'Carteira de Clientes',
      icon: <FolderSharedTwoTone color="primary" />,
      description: 'Como gerenciar sua carteira de clientes',
      topics: [
        'Visualizar clientes ativos',
        'Acompanhar histórico de interações',
        'Gerenciar informações de contato',
        'Acompanhar negociações em andamento',
        'Gerar relatórios de clientes'
      ],
      condition: user?.hascrm
    },
    {
      id: 'fluxo-crm',
      title: 'Fluxo do CRM',
      icon: <MoveDownTwoTone color="primary" />,
      description: 'Como entender o fluxo de trabalho do CRM',
      topics: [
        'Compreender o processo de vendas',
        'Seguir etapas do funil de vendas',
        'Entender status dos leads',
        'Acompanhar ciclo de vida do cliente'
      ],
      condition: user?.hascrm
    }
  ];

  // Filtrar seções baseado nas condições do usuário
  const availableSections = tutorialSections.filter(section =>
    section.condition === undefined || section.condition === true
  );

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      maxWidth: isMobile ? '100%' : isTablet ? '90%' : '800px',
      margin: '0 auto',
      padding: isMobile ? theme.spacing(2) : theme.spacing(3),
      minHeight: '100vh'
    }}>
      <Box sx={{
        textAlign: 'center',
        marginBottom: theme.spacing(3),
        flex: '0 0 auto'
      }}>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          component="h1"
          gutterBottom
          sx={{
            fontSize: isMobile ? '1.5rem' : '2rem',
            fontWeight: 600
          }}
        >
          Tutorial do Sistema
        </Typography>
        <Typography
          variant={isMobile ? "body2" : "subtitle1"}
          gutterBottom
          color="text.secondary"
          sx={{
            fontSize: isMobile ? '0.9rem' : '1rem',
            maxWidth: '600px',
            margin: '0 auto'
          }}
        >
          Aprenda a utilizar todas as funcionalidades disponíveis no menu
        </Typography>
      </Box>

      <Paper
        elevation={2}
        sx={{
          flex: '1 1 auto',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}
      >
        <List sx={{
          flex: '1 1 auto',
          overflow: 'auto',
          padding: 0
        }}>
          {availableSections.map((section, index) => (
            <React.Fragment key={section.id}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => handleToggleSection(section.id)}
                  sx={{
                    padding: isMobile ? theme.spacing(2) : theme.spacing(2, 3),
                    minHeight: isMobile ? 64 : 72
                  }}
                >
                  <ListItemIcon sx={{
                    minWidth: isMobile ? 40 : 56,
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    {section.icon}
                  </ListItemIcon>
                  <ListItemText
                    primary={section.title}
                    secondary={section.description}
                    sx={{
                      '& .MuiListItemText-primary': {
                        fontSize: isMobile ? '1rem' : '1.1rem',
                        fontWeight: 500
                      },
                      '& .MuiListItemText-secondary': {
                        fontSize: isMobile ? '0.8rem' : '0.9rem',
                        display: isMobile ? 'none' : 'block'
                      }
                    }}
                  />
                  {openSections[section.id] ? <ExpandLess /> : <ExpandMore />}
                </ListItemButton>
              </ListItem>

              <Collapse in={openSections[section.id]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {section.topics.map((topic, topicIndex) => (
                    <ListItem
                      key={topicIndex}
                      sx={{
                        pl: isMobile ? 4 : 6,
                        pr: isMobile ? 2 : 3
                      }}
                      disablePadding
                    >
                      <ListItemButton
                        onClick={() => handleTopicClick(topic, section.id)}
                        sx={{
                          padding: isMobile ? theme.spacing(1.5, 0) : theme.spacing(1, 0),
                          '&:hover': {
                            backgroundColor: 'action.hover',
                            '& .MuiListItemIcon-root': {
                              color: 'primary.main'
                            }
                          }
                        }}
                      >
                        <ListItemIcon sx={{
                          minWidth: isMobile ? 32 : 36,
                          display: 'flex',
                          alignItems: 'center'
                        }}>
                          <PlayArrowTwoTone fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                          primary={`${topicIndex + 1}. ${topic}`}
                          sx={{
                            '& .MuiListItemText-primary': {
                              fontSize: isMobile ? '0.85rem' : '0.9rem',
                              color: 'text.secondary',
                              cursor: 'pointer',
                              lineHeight: 1.4
                            }
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  ))}
                </List>
              </Collapse>

              {index < availableSections.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Paper>

      {/* Modal de explicação */}
      {selectedTopic && selectedSection && (
        <TopicExplanation
          topic={selectedTopic}
          sectionId={selectedSection}
          onClose={handleCloseExplanation}
        />
      )}
    </Box>
  );
}